export const CONSULTATION_TOPICS = [
  {
    key: "marriage_delay",
    title: "Why does marriage feel delayed?",
    prompt: "Which house, dasha, or dosha is affecting my marriage timing?",
    intent: "chart_report",
  },
  {
    key: "career_stuck",
    title: "Why is career growth stuck?",
    prompt: "Which planet is blocking my 10th house, and what upay fits?",
    intent: "chart_report",
  },
  {
    key: "dosha_check",
    title: "Do I really have a dosha?",
    prompt: "Do I really have this dosha, and which upay is safe for my chart?",
    intent: "remedy_dosha",
  },
  {
    key: "pattern_repeat",
    title: "Why does this pattern repeat?",
    prompt: "Which dasha is active now, and why does this pattern keep repeating?",
    intent: "chart_report",
  },
];

export const RESULT_PREVIEW = [
  "Lagna, Rashi, Nakshatra, house placements, and current dasha",
  "Mangal, Kaal Sarp, Pitra, Sade Sati, and cancellation checks",
  "Career, marriage, health, money, and spiritual direction",
  "Chart-specific upay instead of generic gemstone or puja advice",
];

export const CONSULTATION_STEPS = [
  {
    label: "1",
    title: "Enter birth details",
    body: "Date and place are enough to start. Birth time improves Lagna and house accuracy.",
  },
  {
    label: "2",
    title: "Get your kundali reading",
    body: "The system calculates your chart with Swiss Ephemeris and Lahiri ayanamsha.",
  },
  {
    label: "3",
    title: "Ask follow-up questions",
    body: "Continue with an AI Jyotishi who reads your kundali before answering.",
  },
];

export const AI_ASTROLOGER_FAQ = [
  {
    question: "Is an AI astrologer accurate?",
    answer:
      "Yes. The planetary calculations use the Swiss Ephemeris, which is accurate to arc-seconds — more precise than manual calculation. The AI interpretation is based on classical Jyotish rules from authoritative texts. For standard consultations like birth chart analysis, dosha detection, and dasha predictions, an AI astrologer delivers thorough and reliable results.",
  },
  {
    question: "Can I chat with the AI astrologer about specific questions?",
    answer:
      "Yes — get your free kundali reading first, then use the in-app chat to ask any follow-up question. Each AI Jyotishi has a distinct consultation style suited to their specialty (marriage, career, health, spirituality).",
  },
  {
    question: "Is the AI astrologer really free?",
    answer:
      "Yes, 100% free with no hidden charges. You can generate unlimited birth chart readings without creating an account or paying anything. There is no premium tier required for basic chart analysis, dosha detection, or dasha predictions.",
  },
  {
    question: "How is this different from Astrotalk or other astrology apps?",
    answer:
      "Most astrology apps charge per consultation or require credits to chat with an astrologer. Our AI astrologer provides free, instant, and unlimited consultations. Additionally, our analysis includes features like Shadbala (planetary strength) scoring, yoga detection, and detailed Vimshottari Dasha timeline — features that many apps reserve for paid tiers.",
  },
  {
    question: "What details do I need to consult the AI astrologer?",
    answer:
      "You need your date of birth and place of birth. Birth time is optional but recommended — with it, the AI can determine your exact Ascendant (Lagna) and provide more precise house placements. Without birth time, you still get accurate Rashi, Nakshatra, and planetary position analysis.",
  },
];

export const AI_ASTROLOGER_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "WebApplication",
  name: "AI Astrologer — Free Vedic Astrology Consultation",
  description:
    "Chat with an AI-powered Vedic astrologer. Get instant birth chart analysis, dosha detection, dasha predictions, and personalized remedies — completely free.",
  url: "https://ishvaram.com/ai-astrologer",
  applicationCategory: "LifestyleApplication",
  operatingSystem: "All",
  offers: {
    "@type": "Offer",
    price: "0",
    priceCurrency: "INR",
  },
  provider: {
    "@type": "Organization",
    name: "Ishvaram",
    url: "https://ishvaram.com",
  },
};
